import { nothing } from '../yambda';

export const captureException = nothing;
export const withScope = nothing;
